import React, { useEffect } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import authEvents from '@src/shared/services/auth-events';
import { useTranslation } from 'react-i18next';
import { defaultLang, languages } from '@src/i18n';
import useActiveLanguage from '@shared/hooks/use-active-language';
import { useKeycloakUserState } from '@src/shared/context/keycloak-user';
import { setContext } from '@apollo/client/link/context';
import {
  ApolloClient,
  ApolloLink,
  ApolloProvider,
  InMemoryCache,
  createHttpLink,
} from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import DatadogService from '@shared/services/datadog';
import { MultiAPILink } from '@habx/apollo-multi-endpoint-link';
export const KeycloakComponentWrapper = ({ children, allowAnonymousAccess = false }: any) => {
  const { initialized, keycloak } = useKeycloak();
  const { languageSetTime } = useActiveLanguage(true);
  const { i18n } = useTranslation();
  const keycloakToken = useKeycloakUserState().keycloakToken;
  if (initialized && !keycloak.authenticated && !allowAnonymousAccess) {
    keycloak.login();
    return null;
  }

  const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
      for (let err of graphQLErrors) {
        switch (err.extensions.code) {
          case 'unauthorized':
            console.log('Authentication Error: unauthorized GraphQL response');
            return forward(operation);
        }
      }
    }

    if (networkError) {
      console.log(`[Network error]: ${networkError}`);
    }
  });

  const authLink = setContext((_, { headers }) => {
    const kc_token = keycloakToken;
    return {
      headers: {
        ...headers,
        authorization: kc_token ? `Bearer ${kc_token}` : '',
      },
    };
  });

  /*   const link = from([errorLink,new HttpLink({
    uri: GRAPHQL.SERVER,
  })]) */

  const createAppolloClient = () => {
    return new ApolloClient({
      link: authLink.concat(
        ApolloLink.from([
          errorLink,
          new MultiAPILink({
            endpoints: {
              live: GRAPHQL.SERVER,
              history: GRAPHQL.SERVER_HISTORY,
              mock: '/',
            },
            createHttpLink: () => createHttpLink(),
          }),
        ])
      ),
      //link: authLink.concat(link) ,
      cache: new InMemoryCache({
        /*         typePolicies: {
          Query: {
            fields: {
              restaurantOrderHistory: {
                keyArgs: false,
                merge(existing, incoming,{readField}) {
                  console.log('Incoming',incoming)
                  const items = existing ? { ...existing.items } : {};
                  console.log('incoming',incoming);
                  incoming.items.forEach((item: any,i:number) => {
                    items[readField('cursor',item) as string] = item;
                  })
                  return items;
                },
                read(existing) {
                  if (existing) {
                    console.log('existing',existing)
                    return {
                      items: {...existing.items},
                    };
                  }
                },
              },
            },
          },
        } */
      }),
    });
  };

  const apolloClient = createAppolloClient();

  useEffect(() => {
    authEvents.subscribeToLogoutKeycloakUser((event) => {
      if (event) {
        DatadogService.removeUser();
        keycloak.logout();
      }
    });
  }, []);

  useEffect(() => {
    if (languages[keycloak?.tokenParsed?.locale as string]?.enabled) {
      i18n.changeLanguage(
        (keycloak.tokenParsed?.auth_time as number) > (languageSetTime as number)
          ? keycloak?.tokenParsed?.locale
          : i18n.language
      );
    } else {
      if (i18n.language !== defaultLang) {
        i18n.changeLanguage(defaultLang);
      }
    }
  }, []);

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};

export default KeycloakComponentWrapper;
